import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfGS",
  "use": "BankOfGS-usage",
  "viewBox": "0 0 68.12 68.124",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68.12 68.124\" id=\"BankOfGS\">\r\n  <defs>\r\n    <style>\r\n      #BankOfGS .cls-1 {\r\n        fill: #b91d22;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfGS_工行logo\" class=\"cls-1\" d=\"M1639,229.991a34.065,34.065,0,1,1,34.07,34.058A34.064,34.064,0,0,1,1639,229.991v0Zm34.06,29.676a29.681,29.681,0,1,0-29.31-29.678,29.68,29.68,0,0,0,29.31,29.678m-19.67-46.906h18.53v5.429h-13.15v5.126h13.15v14.811h-13.15V244.4h13.15v4.838h-18.53V232.649h13.42v-4.5h-13.42V212.761Zm39.34,0V228.15h-13.42v4.5h13.42v16.589h-18.52V244.4h13.14v-6.273h-13.14V223.316h13.14V218.19h-13.14v-5.433h18.52v0Z\" transform=\"translate(-1639 -195.938)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfGS.svg
// module id = nj+j
// module chunks = 37